<template>
  <div v-if="activeBlog">
    <div @click="showBlogProfile" :class="$style.title">{{ activeBlog.blogInfoDisplay.name }}</div>
    <div :class="$style.info">{{ subscribers }} {{ $t('blog.subscribersCount') }}</div>
    <BaseButton
      v-if="isShowSubscribeBtn"
      oval
      :class="[$style.subscribe, { [$style.subscribeTrue]: activeBlog.isSubscribed }]"
      @click="toggleSubscribe"
    >{{ activeBlog.isSubscribed ? $t('blog.unsubscribeBtn') : $t('blog.subscribeBtn') }}</BaseButton>
    <div :class="$style.actions">
      <v-popover v-if="menuComponent" placement="bottom-end" popoverClass="no-arrow">
        <div :class="$style.actionsButton">
          <BaseIcon custom name="ellipsisX" :class="['tooltip-target']" />
        </div>
        <component :is="menuComponent" slot="popover" v-close-popover />
      </v-popover>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BlogMenu from './BlogMenu'
import PostMenu from './BlogPostMenu'
import { SAYHOLA_BLOG_ID, AFFILIATE_BLOG_ID } from '@/utils/config'

export default {
  name: 'blog-info-header',
  components: {
    BlogMenu,
    PostMenu
  },
  props: {
    blogId: String
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      blogById: 'entities/blogs/getBlog' // 'entities/blogs/find'
    }),
    activeBlogId () {
      return this.blogId // this.$route.query.id
    },
    activeBlog () {
      return this.blogById(this.activeBlogId)
    },
    isPostView () {
      return this.$route.name === 'app-blogs-post'
    },
    isBlogView () {
      return this.$route.name === 'app-blogs' && !this.$route.query.isCreatePost
    },
    subscribers () {
      if (this.activeBlog.shortId === SAYHOLA_BLOG_ID) {
        return '3.6M+'
      }
      if (this.activeBlog.shortId === AFFILIATE_BLOG_ID) {
        return '1.6M+'
      }
      return this.activeBlog.subscribers
    },
    menuComponent () {
      if (this.isBlogView) return BlogMenu
      if (this.isPostView) return PostMenu
      return null
    },
    isSayholaBlog () {
      return this.activeBlogId === SAYHOLA_BLOG_ID
    },
    isShowSubscribeBtn () {
      return !this.activeBlog.isOwn && !this.isSayholaBlog
    }
  },
  methods: {
    ...mapActions({
      subscribe: 'entities/blogs/subscribe',
      unsubscribe: 'entities/blogs/unsubscribe'
    }),
    showBlogProfile () {
      const { shortId } = this.activeBlog
      if (this.isBlogView) {
        this.$modal.show('blog-profile', { shortId })
      } else {
        this.$router.push({
          name: 'app-blogs',
          params: {
            blogId: shortId
          }
        })
      }
    },
    toggleSubscribe () {
      if (this.activeBlog.isSubscribed) {
        this.unsubscribe(this.activeBlog)
      } else if (this.activeBlog.isAdult && !this.activeBlog.isOwn) {
        this.$modal.show('confirm', {
          content: this.$t('blogs.confirmAdult', { name: this.activeBlog.blogInfoDisplay.name }),
          onSubmit: () => {
            this.subscribe(this.activeBlog)
          }
        })
      } else {
        this.subscribe(this.activeBlog)
      }
    }
  }
}
</script>

<style module lang="scss">
.title {
  font-size: 16px;
  cursor: pointer;
}
.info {
  flex-grow: 1;
  margin-left: 28px;
  font-weight: 300;
}
.subscribe {
  background: $main-bg-darkest;
  &:hover {
      background: rgba($main-bg-darkest, 0.7);
    }
  &True {
    background: $bg-grey-mid;
    color: $text-dark;
    font-size: 14px;
    &:hover {
      background: rgba($bg-grey-mid, 0.7);
    }
  }
}
.actions {
  display: flex;
  font-size: 20px;
  &Button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 48px;
    margin-left: 10px;
    color: $text-mid-dark;
    &:hover {
      color: $text-colored;
    }
  }
}
</style>
